import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';

import { ExerciseSearchItem } from '../../api/exercises.interface';

interface Props {
    deletingTag?: number;
    exercise?: Pick<ExerciseSearchItem, 'exercise' | 'tag'>;
    visible: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const DeleteExerciseDialog: React.FC<Props> = ({ deletingTag, exercise, visible, onCancel, onConfirm }) => (
    <Dialog maxWidth="xs" open={visible} fullWidth>
        <DialogTitle>
            <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
                <WarningAmberRoundedIcon color="warning" />
                <Typography sx={{ fontWeight: 700 }} variant="h6">Delete Exercise</Typography>
            </Box>
        </DialogTitle>
        <DialogContent dividers>
            <Typography sx={{ mb: 2 }} variant="body1">Are you sure you want to delete this exercise?</Typography>
            <Typography sx={{ fontWeight: 700 }} variant="body2">Exercise: {exercise?.exercise || 'Unknown'}</Typography>
            <Typography sx={{ fontWeight: 700, mb: 2 }} variant="body2">Tag: {exercise?.tag ?? 'Unknown'}</Typography>
            <Typography color="text.secondary" variant="body2">
                This action cannot be undone from the admin UI. The record will be permanently removed from the exercise library.
            </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button color="error" disabled={deletingTag === exercise?.tag} onClick={onConfirm} variant="contained">
                Delete Exercise
            </Button>
        </DialogActions>
    </Dialog>
);

export default DeleteExerciseDialog;